import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import ShuruUserDetail from './ShuruUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyShuruUserDetail } from './companyShuruApi';

/**
 * Company Shuru → one employee's/member's conversation profile.
 * Reuses the shared detail page with the company-scoped fetcher (the backend
 * 404s any user who doesn't belong to this company).
 */
const CShuruUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Shuru Profile | Shoorah</title>
      </Helmet>
      <ShuruUserDetail
        fetcher={fetchCompanyShuruUserDetail}
        backPath={`/${slug}/shuru/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CShuruUserDetail;
